@if(businessCards.length) {
<div class="grid grid-cols-1 gap-x-4 gap-y-6 relative h-full items-stretch auto-rows-fr"
    [ngClass]="businessCards.length > 1 ? [(config?.cols || 'md:grid-cols-3')] : []">
    @for(card of businessCards; track card.key) {
        @if(card['cardType'] === 2) {
            <!-- Platform table cards with icons (cardType 2) -->
            <div [ngClass]="{
                'md:col-span-2': card.colSpan === 2,
                'md:col-span-3': card.colSpan === 3,
                'w-full': !card.colSpan
            }" class="bg-white border border-white/20 dark:border-line dark:bg-surface-1 rounded-lg shadow-md p-6 h-full min-h-full flex flex-col">
                <h2 class="text-lg font-medium mb-4 text-[#141437] dark:text-white">{{ card.heading }}</h2>
                
                @if(card['data']?.tableData?.length) {
                    <div class="overflow-x-auto flex-1">
                        <table class="w-full">
                            <thead>
                                <tr class="border-b border-gray-200 dark:border-gray-700">
                                    @for(header of config?.headers; track $index) {
                                        @if(!header.isPrevious || (header.isPrevious && dateRange.previous_start_date && dateRange.previous_end_date)) {
                                            <th class="text-left py-3 px-4 text-sm font-medium text-gray-600 dark:text-gray-400">
                                                {{ header.label }}
                                            </th>
                                        }
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                @for(row of card['data'].tableData; track $index; let rowIndex = $index) {
                                    <tr class="border-b border-gray-100 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700">
                                        @for(header of config?.headers; track $index) {
                                            @if(!header.isPrevious || (header.isPrevious && dateRange.previous_start_date && dateRange.previous_end_date)) {
                                                <td class="py-3 px-4 text-sm text-gray-800 dark:text-gray-200">
                                                    @if(header.showIcon && row.icon) {
                                                        <div class="flex items-center gap-3">
                                                            <div class="w-8 h-8 rounded-lg bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center">
                                                                <app-icon [name]="row.icon" [size]="18" class="text-blue-600 dark:text-blue-400"></app-icon>
                                                            </div>
                                                            <span class="font-medium">{{ row[header.key] }}</span>
                                                        </div>
                                                    } @else if(header.isPrevious) {
                                                        {{ card['data'].previousTableData[rowIndex]?.[header.key] || 0 }}
                                                    } @else {
                                                        {{ row[header.key] }}
                                                    }
                                                </td>
                                            }
                                        }
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                }
                  @if(isLoading()){
        <app-individual-toaster></app-individual-toaster>
      }
            </div>
        } @else if(card['cardType'] === 3) {
            <!-- Average Contract Value simple stats (cardType 3) -->
            <div [ngClass]="{
                'md:col-span-2': card.colSpan === 2,
                'md:col-span-3': card.colSpan === 3,
                'w-full': !card.colSpan
            }" class="bg-white border border-white/20 dark:border-line dark:bg-surface-1 rounded-lg shadow-md p-6 h-full min-h-full flex flex-col">
                <h2 class="text-lg font-medium mb-4 text-[#141437] dark:text-white">{{ card.heading }}</h2>
                
                @if(card['data']?.tableData?.length) {
                    <!-- Current Period -->
                    <div class="mb-6">
                        <p class="text-sm text-gray-600 dark:text-gray-400 mb-3">
                            Current: {{ formatDateRange(dateRange.start_date, dateRange.end_date) }}
                        </p>
                        <div class="grid grid-cols-3 gap-4">
                            @for(row of card['data'].tableData; track row.label) {
                                <div>
                                    <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">{{ row.label }}:</p>
                                    <div class="flex items-baseline gap-2">
                                        <p class="text-xl font-bold text-gray-900 dark:text-gray-100">{{ formatValue(row.value) }}</p>
                                        @if(card['data']?.previousTableData?.length && dateRange.previous_start_date && dateRange.previous_end_date && row.percentage !== undefined && row.percentage !== null) {
                                            <span [class]="row.percentage >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'" 
                                                  class="text-xs font-medium">
                                                {{ row.percentage > 0 ? '+' : '' }}{{ row.percentage.toFixed(2) }}%
                                            </span>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    
                    <!-- Previous Period (if exists) -->
                    @if(card['data']?.previousTableData?.length && dateRange.previous_start_date && dateRange.previous_end_date) {
                        <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
                            <p class="text-sm text-gray-600 dark:text-gray-400 mb-3">
                                Previous: {{ formatDateRange(dateRange.previous_start_date, dateRange.previous_end_date) }}
                            </p>
                            <div class="grid grid-cols-3 gap-4">
                                @for(row of card['data'].previousTableData; track row.label) {
                                    <div>
                                        <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">{{ row.label }}:</p>
                                        <p class="text-lg font-semibold text-gray-700 dark:text-gray-300">{{ formatValue(row.value) }}</p>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                }
                  @if(isLoading()){
        <app-individual-toaster></app-individual-toaster>
      }
            </div>
        } @else {
            <!-- Regular cards with chart/table toggle (cardType 1) -->
            <app-cards
                [data]="card['data']"
                [cardHeading]="card.heading"
                [valueKey]="getValueKey(card)"
                [curveType]="'curveLinear'"
                [tableHeaders]="getTableHeaders(card)"
                [unit]="dateRange.unit || 'day'"
                [showToggle]="card.showToggles !== false"
                [showLabels]="card.showlabels !== false"
                [defaultView]="card.defaultView || 'chart'"
                [valueFormat]="getValueFormat(card)"
                [ngClass]="{
                    'md:col-span-2': card.colSpan === 2,
                    'md:col-span-3': card.colSpan === 3,
                    'w-full': !card.colSpan
                }"
                [isLoading]="isLoading()"
                >
            </app-cards>
        }
    }
    
</div>
}